import { useMapGetter } from 'dashboard/composables/store';

/**
 * Resolve the current user's access level for sidebar-section based permissions.
 *
 * Levels: 'edit' | 'read' | 'view' | undefined (no access).
 * Administrators always resolve to 'edit'.
 *
 * Use `canEditSection(key)` to gate create/edit/delete actions and
 * `canAccessSection(key)` to gate read-only access.
 */
export function useSectionPermissions() {
  const currentRole = useMapGetter('getCurrentRole');
  const sectionPermissions = useMapGetter('getCurrentSectionPermissions');

  const sectionLevel = key => {
    if (currentRole.value === 'administrator') return 'edit';
    return (sectionPermissions.value || {})[key];
  };

  const canAccessSection = key => Boolean(sectionLevel(key));

  const canEditSection = key => sectionLevel(key) === 'edit';

  return { sectionLevel, canAccessSection, canEditSection };
}

export default useSectionPermissions;
